import { setupWorker } from 'msw/browser';
// import { GENERATED_MSW_HANDLERS } from '../generated/api.msw';
import { handlers } from './handlers';

export const worker = setupWorker(
  ...handlers,
  // ...GENERATED_MSW_HANDLERS(),
);
